export default "__VITE_ASSET__2QyeHWup__"